<template>
  <v-app id="inspire">
    <div v-if="$route.path !== '/demo'">
      <Sidebar :navModel="navModel" @update:navModel="navModel = $event" />
    </div>

    <div v-if="$route.path !== '/demo' && !smAndDown">
      <Header />
    </div>

    <div v-if="$route.path !== '/demo' && smAndDown">
      <SmallHeader :menuClick="menuClick" />
    </div>

    <v-main>
      <router-view />
    </v-main>

    <div v-if="newVersionAvailable" class="new-version-notification v-card">
      <div small class="close-icon"></div>
      <div class="body-1">
        New content is available. Click Refresh to update.
      </div>
      <div class="text-right">
        <v-btn
          @click="refreshPage"
          flex-end
          depressed
          class="caption mt-3 bold-text primary"
        >
          Refresh
        </v-btn>
      </div>
    </div>

    <!-- <Footer /> -->
  </v-app>
</template>

<script>
import { presets } from '@/utils/presets/index'
import { mapActions, mapMutations, mapState } from 'vuex'
import Header from './components/Header'
import SmallHeader from './components/SmallHeader'
import Sidebar from './components/Sidebar'
import { getConfigPageVersion } from '@/utils/helpers'

export default {
  name: 'App',
  data: () => ({
    navModel: {
      val: false
    },
    newVersionAvailable: false
  }),
  components: {
    SmallHeader,
    Header,
    Sidebar
  },
  computed: {
    ...mapState({
      preset: ({ config }) => config.preset
    }),
    smAndDown() {
      return this.$smallScreen
    }
  },
  methods: {
    ...mapActions(['setConfigs', 'updateTheme']),
    ...mapMutations(['setCashierVersion', 'setPresets']),
    menuClick() {
      this.navModel.val = !this.navModel.val
    },
    refreshPage() {
      window.location.reload(true)
    }
  },
  async mounted() {
    const newVersionAvailable = await getConfigPageVersion()
    this.newVersionAvailable = newVersionAvailable
  },
  created() {
    this.setPresets(presets)
    const notDemoPage =
      !window.__PiqCashierConfigs__ &&
      this.$route.path !== '/configs' &&
      !window.location.hash.includes('__PiqCashierConfigs__')
    if (notDemoPage) {
      this.$router.push('/configs')
    }
    try {
      const presetSaved =
        localStorage.presets && JSON.parse(localStorage.getItem('presets'))
      const isSaved = presetSaved && presetSaved[this.preset]
      if (isSaved) {
        console.log(`Using "${[this.preset]}" from localstorage`)
        this.setConfigs(isSaved.config)
        this.updateTheme(isSaved.theme)
      }
    } catch (err) {
      console.log(err)
    }
    // Theme is set via Vuetify config
  }
}
</script>

<style lang="scss">
@use './utils/styles/main.scss';
</style>
